document.addEventListener('DOMContentLoaded', function () {
  const productCards = document.querySelectorAll(".js-nova-product-card");
  productCards.forEach((card) => {
    card.addEventListener("click", (event) => {
      const productCard = event.currentTarget;
      const data = {
        productId: productCard.getAttribute("id"),
        productName: productCard.getAttribute("title"),
        productPrice: Number(productCard.getAttribute("data-analytics-price")),
        productSku: productCard.getAttribute("sku"),
      };
      Shopify.analytics.publish("custom_product_clicked", { data });
    })
  })
});

document.addEventListener("nova:analyticsProductRemoved", async (event) => {
  const response = await fetch("/cart.js");
  const cart = await response.json();
  Shopify.analytics.publish('custom_product_removed_from_cart', { data: {cart, removedProduct: event.detail} });
});
